import React, { useState } from "react";
import { FaPen } from "react-icons/fa";

const FloatingLabelInput = ({
  label,
  value,
  onChange,
  type = "text",
  readOnly = false,
  max,
  errorMessage = "", // new prop for error
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [iseReadOnly, setIsReadOnly] = useState(readOnly);

  return (
    <div className="flex flex-col max-w-[380px] w-full min-w-[280px]">
      <div
        onClick={() => {
          if (iseReadOnly) {
            setIsReadOnly(false);
          }
        }}
        className={`relative border-[1px] font-atkinson rounded-lg px-4 pt-4 pb-1 transition-all ${
          isFocused ? errorMessage ? "border-red-500" : "border-blue-500": "border-gray-300"
        }`}
      >
        {/* Label */}
        <label
          className={`absolute left-4 text-gray-500 transition-all pointer-events-none ${
            isFocused || value
              ? "text-xs top-1 bg-white px-1"
              : "text-base top-4"
          }`}
        >
          {label}
        </label>

        {/* Input */}
        <input
          type={type}
          value={value}
          onChange={onChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          className="w-full outline-none bg-transparent text-lg"
          readOnly={iseReadOnly}
          max={max}
        />

        {/* Edit Icon */}
        {iseReadOnly && (
          <FaPen
            onClick={() => {
              if (iseReadOnly) {
                setIsReadOnly(false);
              }
            }}
            className="absolute right-4 top-1/2 -translate-y-1/2 text-gray-400 cursor-pointer"
          />
        )}
      </div>

      {/* Error message */}
      {errorMessage && (
        <span className="text-red-500 text-sm mt-1">{errorMessage}</span>
      )}
    </div>
  );
};

export default FloatingLabelInput;
